import fromOptionsToElement from 'utils/converters/options/fromOptionsToElement.util.';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';

const L = logger('elementRect');

const elementRect = withOptions((options) => {
  try {
    const element = fromOptionsToElement(options);
    if (!element) {
      L.warn('()', 'Invalid element in options:', options);
      return new DOMRect();
    }

    // SEE: https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
    return element.getBoundingClientRect();
  } catch (e) {
    L.warn('()', 'options:', options, e);
    return new DOMRect();
  }
});

export default elementRect;
